<template>
  <div v-if="is_access == true">
    <v-dialog v-model="dialog" 
      persistent
      width="650">
      <v-card class="border-radius box-shadow">
        <v-card-title class="pb-0">
          <v-btn
            small
            outlined
            color="green"
            class="text-capitalize mr-2"
            @click="addDiscount()">
            Tambahkan Diskon
          </v-btn>
          <v-btn
            v-if="discount.price_discount.length > 0"
            small
            outlined
            color="red"
            class="text-capitalize"
            @click="discount.price_discount = []; discount.discount_value = 0;">
            Hapus Semua
          </v-btn>
        </v-card-title>
        <v-divider class="mt-5 mb-2" v-if="discount.price_discount.length > 0"/>
        <v-card-title class="py-0" v-if="discount.price_discount.length > 0">
          <v-row
            v-for="(item, index) in discount.price_discount"
            :key="index">
            <v-col cols="1">
              <div style="width: 32px;">
                <v-chip
                  class="px-0 d-flex justify-center align-center"
                  style="width: 100px; border-radius: 0px !important;"
                  label>
                  {{ index+1 }}
                </v-chip>
                <v-chip
                  style="border-radius: 0px !important;"
                  label
                  color="red"
                  class="px-1 text-center cursor-pointer"
                  @click="removeDiscount(index)">
                  <v-icon color="white">mdi-close</v-icon>
                </v-chip>
              </div>
            </v-col>
            <v-col cols="11">
              <v-row>
                <v-col cols="6" class="py-0">
                  <v-text-field
                    dense
                    outlined
                    label="Judul"
                    :color="style.primary"
                    prepend-inner-icon="mdi-text"
                    v-model="item.title">
                  </v-text-field>
                </v-col>
                <v-col cols="6" class="py-0">
                  <v-currency-field 
                    dense
                    outlined
                    label="Diskon"
                    :color="style.primary"
                    prepend-inner-icon="mdi-cash-100"
                    v-model="item.price">
                  </v-currency-field>
                </v-col>
              </v-row>

              <v-textarea
                clearable
                clear-icon="mdi-cancel"
                :color="style.primary"
                label="Keterangan"
                auto-grow
                outlined
                row-height="10"
                v-model="item.desc">
              </v-textarea>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="pa-0" v-if="discount.price_discount.length < 1">
          <v-divider class="my-6"/>
          <p class="body-2 text-second text-center my-16">
            Belum ada Diskon
          </p>
          <v-divider class="my-6"/>
        </v-card-text>
        <v-card-text class="pt-0 pb-0">
          <v-alert type="error" text dense prominent 
            v-show="error.message.length > 0"
            v-html="error.message">
          </v-alert>
        </v-card-text>
        <v-card-actions class="pb-5 px-6">
          <v-spacer/>
          <v-btn
            outlined
            small
            :color="style.primary"
            class="text-capitalize green--text mx-1"
            :disabled="process.run"
            :loading="process.run"
            @click="saveDiscount();">
            <v-icon small class="mr-1">mdi-check</v-icon>
            Simpan
          </v-btn>
          <v-btn 
            outlined 
            small
            color="red"
            class="text-capitalize red--text"
            :disabled="process.run"
            @click="calculate(); dialog = false;">
            <v-icon small class="mr-1">mdi-close-circle</v-icon>
            Batalkan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12" class="py-0">
        <v-card flat min-height="800">
          <v-card-text :class="$vuetify.breakpoint.name === 'xs' ? 'px-0':''">
            <v-row>
              <v-col cols="12" md="5" :class="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm' ? 'pb-0':'py-0'">
                
              </v-col>
              <v-col cols="12" md="4" :class="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm' ? 'pb-0':'py-0'">
                <v-text-field
                  outlined
                  dense
                  :hide-details="true"
                  placeholder="Cari Pengajuan Diskon . . ."
                  clearable
                  :color="style.primary"
                  v-model="filter.title"
                  @click:clear="filter.title = ''; fetch();"
                  v-on:keyup.enter="fetch()"
                  prepend-inner-icon="mdi-magnify">
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3" :class="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm' ? 'pb-0':'py-0'">
                <v-select
                  dense
                  outlined
                  :items="[
                    {
                      label: 'Semua',
                      value: ''
                    },
                    {
                      label: 'Menunggu Konfirmasi Supervisor',
                      value: '1'
                    },
                    {
                      label: 'Disetujui',
                      value: '0'
                    }
                  ]"
                  item-text="label"
                  item-value="value"
                  item-color="light-green lighten-2"
                  v-model="filter.status"
                  v-on:change="fetch()"
                  label="Status"
                  :color="style.primary"
                  hide-details>
                  <template v-slot:append>
                    <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider class="mx-4"/>
          <v-card-text :class="$vuetify.breakpoint.name === 'xs' ? 'px-0 py-0':'py-0'" style="min-height: 600px;">
            <v-skeleton-loader
              :loading="process.run"
              transition="scale-transition"
              :tile="false"
              type="table-tbody">
              <v-simple-table>
                <template v-slot:default>
                  <thead v-if="!process.run && list.length > 0">
                    <tr>
                      <th class="text-left pl-0" width="300">Proyek</th>
                      <th class="text-left">Unit / Blok</th>
                      <th class="text-left">Konsumen</th>
                      <th class="text-right">Diskon</th>
                      <th class="text-left">Diajukan</th>
                      <th class="text-left" width="200">Status</th>
                      <th class="text-left"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr 
                      v-for="(item, index) in list" 
                      :key="index">
                      <td class="text-second pl-0">
                        {{ item.project_name }}
                      </td>
                      <td class="text-second">
                        <p class="mb-1">
                          {{ item.unit_type_name }} - {{ item.unit_label }}
                        </p>
                        <p class="text-third font-weight-bold mb-0" style="font-size: 10px;">
                          {{ parseInt(item.unit_price) | price }}
                        </p>
                      </td>
                      <td class="text-second">
                        <p class="mb-1">
                          {{ item.place_order_user_name }}
                        </p>
                        <p class="text-third font-weight-bold mb-0" style="font-size: 10px;">
                          {{ item.place_order_user_mobilephone }}
                        </p>
                      </td>
                      <td class="text-second text-right">
                        {{ parseInt(item.transaction_discount_value) | price }}
                      </td>
                      <td class="text-second text-capitalize">
                        <span v-if="item.booking_closing_datetime !== ''">
                          {{ item.booking_closing_datetime | date }}
                        </span>
                        <span v-else>
                          -
                        </span>
                      </td>
                      <td class="font-weight-bold text-capitalize"
                        :class="item.transaction_status_discount_review === '1' ? 'color-default' : 'teal--text'">
                        {{ item.transaction_status_discount_review === '1' ? 'Menunggu Konfirmasi Supervisor' : 'Disetujui' }}
                      </td>
                      <td class="text-right pr-0">
                        <v-btn v-if="item.transaction_status_discount_review === '1' && (user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('supervisor')) && item.transaction_is_canceled === '0'"
                          small
                          width="120"
                          outlined
                          :color="style.primary"
                          class="text-capitalize mx-1"
                          @click="dialog = true; detail = item;">
                          <v-icon small class="mr-1">mdi-check</v-icon>
                          Konfirmasi
                        </v-btn>
                        <v-btn v-if="(item.transaction_status_discount_review === '0' && item.transaction_is_canceled === '0') || (user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('supervisor'))"
                          small
                          width="120"
                          outlined
                          color="grey"
                          class="text-capitalize mx-1"
                          :href="`/project/unit/transaction/booking/${item.booking_id}?transaction=${item.transaction_id}&unit=${item.unit_id}`"
                          target="_blank">
                          <v-icon small class="mr-1">mdi-information-outline</v-icon>
                          Info Booking
                        </v-btn>
                        <span class="red--text font-weight-bold" v-if="item.transaction_status_discount_review === '1' && item.transaction_is_canceled === '0' && (user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('supervisor'))">
                          -
                        </span>
                        <span class="red--text font-weight-bold" v-if="item.transaction_is_canceled === '1'">
                          Booking Dibatalkan
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-skeleton-loader>
            <div class="d-flex align-center text-center text--secondary my-12 py-12" style="min-height: 550px;" v-if="!process.run && pagination.total_page < 1">
              <v-img 
                class="my-12"
                contain
                width="200"
                height="200"
                :src="require('../../assets/404/404.svg')">
              </v-img>
            </div>
            <v-divider/>
          </v-card-text>
          <v-card-text :class="$vuetify.breakpoint.name === 'xs' ? 'pt-0':''">
            <v-row justify="end" align="center" v-if="pagination.total_page > 1">
              <v-col cols="12" md="2" class="d-flex align-center justify-end">
                <v-btn
                  :color="style.primary"
                  :disabled="pagination.current === 1"
                  elevation="3"
                  min-width="36"
                  class="text-capitalize white--text px-0 mr-3"
                  @click="selected.pagination = 1">
                  <v-icon>mdi-chevron-double-left</v-icon>
                </v-btn>
                <v-btn
                  color="#263238"
                  :disabled="pagination.current < 2"
                  elevation="3"
                  min-width="36"
                  class="text-capitalize white--text px-0"
                  @click="selected.pagination = selected.pagination-1">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <div class="mx-5" style="width: 75px;">
                  <v-autocomplete
                    v-model="selected.pagination"
                    :items="pagination.detail"
                    color="#263238"
                    auto-select-first
                    outlined
                    dense
                    single-line
                    hide-details
                    hide-selected>
                    <template v-slot:selection="{ item }">
                      {{ item }}
                    </template>
                  </v-autocomplete>
                </div>
                <v-btn
                  color="#263238"
                  elevation="3"
                  min-width="36"
                  class="text-capitalize white--text px-0"
                  :disabled="pagination.current >= pagination.total_page"
                  @click="selected.pagination = selected.pagination+1">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
                <v-btn
                  :color="style.primary"
                  :disabled="pagination.current === pagination.total_page"
                  elevation="3"
                  min-width="36"
                  class="text-capitalize white--text px-0 ml-3"
                  @click="selected.pagination = pagination.total_page">
                  <v-icon>mdi-chevron-double-right</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../service/Axios";
  export default {
    data () {
      return {
        option: {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline'],
              [{ 'list': 'ordered'}, { 'list': 'bullet' }],
              [{ 'size': ['small', false, 'large', 'huge'] }],
              [{ 'color': [] }, { 'background': [] }],
              [{ 'align': [] }]
            ]
          },
          placeholder: 'Keterangan'
        },
        dialog: false,
        selected: {
          pagination: 1
        },
        filter: {
          title: '',
          status: '1'
        },
        page: 1,
        list: [],
        pagination: {},
        detail: {},
        discount: {
          discount_value: 0, // DISKON
          price_discount: [{
            id: 0,
            title: '',
            price: 0,
            desc: ''
          }]
        },
        process: {
          run: false,
          form: false
        },
        error: {
          message: ''
        },
        style: {
          primary: "#8BC541"
        },
        role: ['superuser', 'supervisor'],
        is_access: false
      }
    },
    components: {
      
    },
    computed: {
      user () {
        return this.$store.state.user
      }
    },
    watch: {
      'selected.pagination': function(val) {
        this.fetch(val)
      },
      'detail': function(val) {
        this.discount.price_discount = val.transaction_discount_detail
        this.discount.discount_value = parseInt(val.transaction_discount_value)
      }
    },
    mounted () {
      this.fetch()

      this.user.user_company_roles_name.forEach(obj => {
        if (this.role.includes(obj)) {
          this.is_access = true
        }          
      })
    },
    methods: {
      async fetch(p) {
        this.process.run = true

        let params = {
          page: p,
          limit: 12,
          search: this.filter.title,
          status_discount_review: this.filter.status
        }

        await get(`auth/company/project/list-unit-transaction`, { params })
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.process.run = false
            this.list = res.data.results
            this.pagination = res.data.pagination
            this.pagination.current = parseInt(this.pagination.current)
          }
        })
      },
      addDiscount() {
        this.discount.price_discount.push({
          id: 0,
          title: '',
          price: 0,
          desc: ''
        })
      },
      removeDiscount(index) {
        this.discount.price_discount.splice(index, 1)
      },
      calculate() {
        let total = this.discount.price_discount.reduce( ( sum, { price } ) => sum + price , 0)

        this.discount.discount_value = total
      },
      async saveDiscount() {
        this.error.message = ''
        this.process.form = true

        this.calculate()

        await post(`auth/transaction/update-and-approve-discount`, {
          data: {
            transaction_id: this.detail.transaction_id,
            discount_value: this.discount.discount_value,
            price_discount: JSON.stringify(this.discount.price_discount)
          }
        }).then(response => {
          let res = response.data
          if (res.status === 200) {
            this.dialog = false
            this.process.form = false

            this.discount = {
              discount_value: 0, // DISKON
              price_discount: [{
                id: 0,
                title: '',
                price: 0,
                desc: ''
              }]
            }

            this.fetch()
          } else {
            this.process.form = false
            this.error.message = res.msg
          }
        })
      }
    }
  }
</script>